const track = (identifier: string) =>
  GustoAnalytics.track({
    eventCategory: 'Dom',
    eventName: 'Click',
    data: {
      identifier: `account_already_exists_dialog: ${identifier}`,
    },
  });

export default track;
